import { FC, memo, useMemo } from 'react'
import { IconButton, Button, ButtonProps } from '@chakra-ui/react'

import { SpinningArrows } from 'components/icons'

type CustomVariant = {
  [key: string]: object
}

type Props = ButtonProps & {
  children?: string
  customVariant?: 'IN-DRAWER' | 'DEFAULT'
  'aria-label'?: string
}

const RefreshButton: FC<Props> = ({ children, customVariant = 'DEFAULT', variant = 'ghost', ...props }) => {
  const selectedCustomVariant = useMemo(() => {
    const customVariants: CustomVariant = {
      DEFAULT: {},
      'IN-DRAWER': {
        _hover: { bg: 'primary', color: 'light' },
        minWidth: { base: '100%', sm: '100%', md: '200px' },
      },
    }

    return customVariants[customVariant]
  }, [customVariant])

  if (children) {
    return (
      <Button
        variant="outline"
        color="dark"
        _hover={{ bg: 'primary', color: 'light' }}
        leftIcon={<SpinningArrows />}
        {...props}
        {...selectedCustomVariant}
      >
        {children}
      </Button>
    )
  }

  return (
    <IconButton aria-label={props['aria-label'] || 'Recarregar'} variant={variant} icon={<SpinningArrows />} {...props}>
      {children}
    </IconButton>
  )
}

export default memo(RefreshButton)
